import React from 'react';
export function Footer() {
  return <footer className="bg-white border-t border-slate-100 px-5 py-10" data-id="element-98">
      <div className="max-w-3xl mx-auto text-center space-y-3" data-id="element-99">
        <p className="font-bold text-brand-ink" data-id="element-100">Crecer Jugando</p>
        <p className="text-xs text-slate-500 max-w-md mx-auto" data-id="element-101">
          Acompañando a familias a estimular el desarrollo infantil desde casa,
          sin pantallas y sin estrés.
        </p>
        <p className="text-[11px] text-slate-400" data-id="element-102">
          © {new Date().getFullYear()} Crecer Jugando. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}